import { Button, InputLabel, SxProps, Typography } from '@mui/material';
import { IFilterTag } from '..';
import { useIsDesktop } from 'Hooks';

export interface IToggleableChip {
  chip: IFilterTag;
  onClick: (chip: string) => void;
  sx?: SxProps;
}
export const ToggleableChip = ({ chip, onClick, sx }: IToggleableChip) => {
  const isDesktop = useIsDesktop();

  return (
    <Button
      onClick={() => onClick(chip.label)}
      color='primary'
      role={'switch'}
      aria-labelledby={`label-chip-${chip.label}`}
      aria-pressed={chip.isActive}
      aria-aria-checked={chip.isActive}
      tabIndex={0}
      sx={{
        height: isDesktop ? '38px' : '32px',
        outline: (theme) =>
          chip.isActive
            ? 'none'
            : `1px solid ${theme.palette.primary.shade_100}`,
        background: (theme) =>
          chip.isActive ? theme.palette.primary.main : '#fff',
        color: (theme) => (chip.isActive ? '#fff' : theme.palette.primary.main),
        '&:hover': {
          backgroundColor: (theme) =>
            chip.isActive ? theme.palette.primary.main : '#fff',
        },
        ...sx,
      }}
    >
      <InputLabel id={`label-chip-${chip.label}`}>
        <Typography
          variant='body6'
          color={chip.isActive ? '#fff' : 'primary.main'}
          sx={{
            cursor: 'pointer',
          }}
        >
          {chip.label}
        </Typography>
      </InputLabel>
    </Button>
  );
};
